import React from 'react';
import { Thermometer } from 'lucide-react';

interface TemperatureDisplayProps {
  roomTemperature: number;
}

const TemperatureDisplay: React.FC<TemperatureDisplayProps> = ({ roomTemperature }) => {
  const getTemperatureColor = (temp: number): string => {
    if (temp >= 1000) return 'text-red-500';
    if (temp >= 500) return 'text-orange-500';
    if (temp >= 100) return 'text-yellow-500';
    if (temp <= -10) return 'text-cyan-400';
    if (temp <= 0) return 'text-blue-400';
    return 'text-green-400';
  };

  const getTemperatureIcon = (temp: number) => {
    if (temp >= 500) return '🔥';
    if (temp <= 0) return '❄️';
    return '🌡️';
  };

  return (
    <div className="absolute top-4 right-4 z-10">
      <div className="bg-gray-800/90 backdrop-blur-md rounded-xl p-3 shadow-xl border border-gray-700/50 flex items-center gap-3">
        <div className="flex items-center gap-2">
          <Thermometer className={`w-5 h-5 ${getTemperatureColor(roomTemperature)}`} />
          <span className="text-2xl">{getTemperatureIcon(roomTemperature)}</span>
        </div>
        <div>
          <div className="text-xs text-gray-400 uppercase tracking-wider">Avg Temp</div>
          <div className={`text-xl font-bold ${getTemperatureColor(roomTemperature)}`}>
            {roomTemperature}°C
          </div>
        </div>
      </div>
    </div>
  );
};

export default TemperatureDisplay;
